import { useQuery } from '@tanstack/react-query';

import regularStatus from '../../../regular/status';
import fetch from './fetch';

function useMtPortfolio() {
  const { cb, key } = fetch();

  const { isMtActive } = regularStatus.useAccountStatus();

  const enabled = isMtActive; // Do not call when user does not have MT account

  const { data, isSuccess, refetch } = useQuery(key, cb, { enabled });

  return { data, isSuccess, refetch };
}

export default useMtPortfolio;
